import { grey, teal, red } from "@mui/material/colors";

export const DrawerWidth = 300;
export const DashboardDrawerWidth = 300;
export const AnnotationDrawerWidth = 300;
export const MenuZIndex = 1002;
export const HeaderFooterZIndex = 1001;
export const SidebarZIndex = 1000;
export const SuccessColor = teal[500];
export const ErrorColor = red[500];
export const SidebarColor = grey[50];

export const LayoutChildMarginTop = "104px";
